import { createContext, useContext } from "react";

import { noop } from "ts-essentials";
import type { ReviewSelection } from "src/components/llm/context-suggestions/types";

/** Chat links copied before Context Hub used the shared agent sidebar: /context-hub/knowledge?sessionId=... */
export const LEGACY_SESSION_ID_PARAM = "sessionId";

export type ContextAgentPanelContextType = {
  /** Expand the chat panel. */
  openPanel: () => void;
  /** Expand the chat panel with this text in its composer, unsent. */
  openPanelWithDraft: (prompt: string) => void;
  /** The session the review panel is showing, or null when it is closed. */
  reviewSelection: ReviewSelection | null;
  /** Open the review panel on a session. */
  openReview: (selection: ReviewSelection) => void;
  closeReview: () => void;
  /** Width the chat column takes on the right, or 0 when there is no chat. */
  chatWidthPx: number;
  isChatOverlayOpen: boolean;
  /** Width of the page column's scrollbar, or 0 when scrollbars overlay the content. */
  pageScrollbarWidthPx: number;
};

// Provided by ContextHubLayout, which owns the panel; consumed by any Context
// Hub page that wants to open the panel (empty-state CTAs).
export const ContextAgentPanelContext =
  createContext<ContextAgentPanelContextType>({
    openPanel: noop,
    openPanelWithDraft: noop,
    reviewSelection: null,
    openReview: noop,
    closeReview: noop,
    chatWidthPx: 0,
    isChatOverlayOpen: false,
    pageScrollbarWidthPx: 0,
  });
ContextAgentPanelContext.displayName = "ContextAgentPanelContext";

export const useContextAgentPanel = () => useContext(ContextAgentPanelContext);
